import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-surface py-20 lg:py-28" aria-labelledby="faq" data-id="element-97" data-mp="1bmd6p6zvac52">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 lg:grid-cols-[1fr_2fr] lg:gap-16" data-id="element-98" data-mp="1gk5b30hp7qq5">
        <h2 id="faq" className="font-display text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl" data-id="element-99" data-mp="24ahdxwy36x9v">
          Preguntas frecuentes
        </h2>
        <ul className="divide-y divide-line border-y border-line" data-id="element-100" data-mp="1ujedmxczembn">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <li key={faq.question} data-id="element-101" data-mp="2n8btyuxmu91r" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-ink" data-id="element-102" data-mp="2n7abw6i78maj">
                  <span className="font-display text-lg font-extrabold text-ink sm:text-xl" data-id="element-103" data-mp="1eldbuhy6nba7">{faq.question}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-104" data-mp="19tc2b3sefynv" />
                </button>
                <AnimatePresence initial={false} data-id="element-105" data-mp="1xk7sxxl4cntj">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-106" data-mp="1skd1nsxflw7y">
                      <div className="space-y-2 pb-6 pr-10 text-muted" data-id="element-107" data-mp="237y35qewd0y5">
                        {faq.answer.map(line => <p key={line} data-id="element-108" data-mp="2867tnnpofddf">{line}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}